module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image1-be462e11ee603c4caf078603821bb98d.png";